import fetch from "../utils/fetch";

/**
 * 激活用户的所有post
 * http://schedulepost.dev.apphi.com/api/docs/#!/posts/Post_activate_all
 * @param publisherId 用户id
 * @returns {*}
 */
export function active({ publisherId }) {
  return fetch.post(
    "posts/activate/all",
    {},
    {
      headers: {
        "X-Apphi-Request-Publisher-Id": publisherId,
      },
    }
  );
}
/**
 * 获取验证的post信息
 * @param token url上的token
 * @returns {*}
 */
export function getPostBy({ token }) {
  return fetch.get(`posts/${token}`, {
    ignoreToken: true,
  });
}
/**
 * 审核信息
 * @param token url上的token
 * @param status 评审状态 2：接受，3：拒绝
 * @returns {*}
 */
export function approvePostBy({ token, status }) {
  return fetch.patch(`posts/${token}`, { reviewing_status: status });
}



// WEBPACK FOOTER //
// ./src/apis/post.js